import { Component } from '@angular/core';

@Component({
  selector: 'seira-visao-geral',
  templateUrl: './visao-geral.component.html',
  styleUrls: ['./visao-geral.component.scss']
})
export class VisaoGeralComponent {
  textoPrincipal = [
    `O Governo do Estado da Paraíba, por meio da Agência Executiva de Gestão das Águas (AESA), desenvolveu o Sistema Estadual de Informações de Riscos Agrohidroclimáticos (SEIRA) em parceria com o Projeto Cooperar e financiado pelo Banco Mundial, no âmbito do Projeto Paraíba Rural Sustentável. O SEIRA surgiu como uma ferramenta estratégica para a gestão integrada de riscos climáticos e agrícolas, promovendo maior segurança e planejamento para o setor rural da Paraíba.`,

    `O sistema reúne dados de previsão do tempo e clima (diários, mensais e sazonais), monitoramento agrohidroclimático em tempo real, alertas de eventos extremos (como secas e inundações), além de mapas, gráficos, tabelas e índices que subsidiam decisões agrícolas e ambientais. Todas essas informações estão disponíveis por meio de um portal web público, gratuito e de fácil acesso.`
  ];

  listaProdutos = [
    'Monitoramento e alertas de risco climático',
    'Zoneamento agrícola municipal',
    'Calendário agrícola com datas indicadas para plantio',
    'Dados fenológicos e de produtividade',
    'Mapas e análises da qualidade da água dos principais corpos hídricos',
    'Definição de culturas aptas por região, com base em variáveis geomorfológicas e climáticas'
  ];

  textoFinal = [
    `Durante eventos técnicos nacionais e regionais, o sistema tem sido apresentado como um exemplo de política pública voltada à resiliência climática e à integração de dados meteorológicos com ações estratégicas no campo. A troca de experiências com outras instituições tem enriquecido o processo de desenvolvimento e fortalecido a atuação do estado no enfrentamento aos desafios impostos pelas mudanças climáticas.`,

    `Com o SEIRA, a Paraíba dá um passo decisivo rumo a um modelo de desenvolvimento rural sustentável, resiliente e orientado por dados, ampliando o acesso à informação de qualidade para agricultores, gestores públicos e toda a sociedade.`
  ];
}
